import React, { useEffect, useState } from 'react';
import { InputGroup, Panel } from 'react-bootstrap';
import _ from 'lodash';
import { columns, sorting } from './BranchOfficesListSchema';
import { useBranchOfficeStore } from '../../../store/providers/BranchOffice';
import Permission from '../../../components/Permission/Permission';
import * as constants from '../../../constants';
import FormInput from '../../../components/FormInput/FormInput';
import OptionsHelper from '../../../lib/OptionsHelper';
import {useFranchiseStore} from "../../../store/providers/Franchise";
import {useDispatch} from "react-redux";
import {franchiseSuccess} from "../../../store/actions/franchise";
import { officeSelect } from '../../../store/actions/office';

const BaseList = React.lazy(() => import('../../../components/Lists/BaseList/BaseList'));
const OfficeModal = React.lazy(() => import('../../../components/Modals/OfficeModal/OfficeModal'));

function BranchOfficesTab(props) {
    const dispatch = useDispatch();
    const { selectRecord, BranchOfficesForDashboard, data } = useBranchOfficeStore();
    const { selectRecord: franchiseSelectRecord, data: franchiseData } = useFranchiseStore();

    const [isMounted, setIsMounted] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [listData, setListData] = useState([]);
    const pagePermission = constants.PERMISSION_DASHBOARD;
    const [hasPermission, setHasPermission] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [instanceTypeOptions, setInstanceTypeOptions] = useState();
    const [selectedType, setSelectedType] = useState();
    const instanceTypeList = ['Corporate', 'Non Corporate'];
    const [officeData, setOfficeData] = useState();
    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        if (!_.isEmpty(data)) {
            if (data.status === 'success' && data.scope === 'BranchOfficesForDashboard') {
                let listData = data.body;
                if (selectedType) {
                    if(selectedType === 'Corporate') {
                        listData = data.body.filter((e) => e.corporateOwned == true);
                    } else if(selectedType === 'Non Corporate') {
                        listData = data.body.filter((e) => e.corporateOwned == false);
                    }
                }

                setListData(listData);
            }
            if (data.status === 'success' && data.scope === 'select') {
                setOfficeData(data.body);
            }
            setIsBusy(data.status === 'processing' && data.scope === 'BranchOfficesForDashboard');
        }
    }, [data, selectedType]);

    useEffect(() => {
        if (!hasPermission) { return; }
        if (isMounted) { return; }
        BranchOfficesForDashboard();

        if (!_.isEmpty(instanceTypeList)) {
            let listInstanceTypeOptions = [];
            instanceTypeList.forEach((a) => {
                listInstanceTypeOptions.push({ id: a, name: a });
            });
            setInstanceTypeOptions(OptionsHelper({ list: listInstanceTypeOptions, includeBlank: true, includeBlankName: 'All' }));
        }
        setIsMounted(true);
    }, [isMounted, hasPermission]);

    const changedHandler = (id, value) => {
        if (value === 'Corporate' || value === 'Non Corporate') {
            setSelectedType(value);
            BranchOfficesForDashboard();
        } else {
            setSelectedType();
            BranchOfficesForDashboard();
        }
    }

    const moreFilters = () => {
        return (
            <>
                <div style={{ paddingLeft: '1%' }}>
                    <InputGroup style={{ width: '270px' }}>
                        <InputGroup.Addon>Instance Type:</InputGroup.Addon>
                        <FormInput
                            id="typeId"
                            type="select"
                            required={false}
                            labelText=''
                            errorMessage={''}
                            changed={(id, value) => changedHandler(id, value)}
                            value={selectedType || ''}
                        >
                            {instanceTypeOptions}
                        </FormInput>
                    </InputGroup>
                </div>
            </>
        )
    }

    useEffect(() => {
        if (!_.isEmpty(franchiseData) && franchiseData.scope === 'select' && franchiseData.status === 'success') {
            dispatch(franchiseSuccess({ franchise: franchiseData.body }));
        }
    }, [franchiseData, dispatch]);


    const selectedHandler = (office) => {
        if (_.isEmpty(office)) { return; }
        dispatch(officeSelect({ officeId: office.id }));
        selectRecord({ officeId: office.id });

        const franchiseId = office.franchiseId;
        if (franchiseId) {
            franchiseSelectRecord({ franchiseId });
        }

        setIsEditing(true);
    };

    const cancelledHandler = () => {
        setIsEditing(false);
    };

    const submittedHandler = () => {
        setIsEditing(false);
    };

    return (
        <>
            <Permission pagePermission={pagePermission} hasPermission={hasPermission} setHasPermission={setHasPermission} setCanEdit={setCanEdit} />
            {hasPermission &&
                <>
                    {
                        isEditing && officeData?.id && franchiseData?.body?.id &&
                        <OfficeModal
                            show={true}
                            size="large"
                            franchise={franchiseData?.body}
                            branchOffice={officeData}
                            title="Edit Branch Office"
                            submitted={() => submittedHandler()}
                            cancelled={() => cancelledHandler()} />
                    }
                    <Panel>
                        <Panel.Body>
                            <BaseList
                                compType="BranchOffice"
                                activeValue="Active"
                                activeField="status"
                                listData={listData}
                                isBusy={isBusy}
                                sorting={sorting}
                                columns={columns}
                                hideCopy={true}
                                permissionEdit={canEdit}
                                hidePrint={true}
                                hideAdd={true}
                                hideEdit={false}
                                hideDelete={true}
                                hideRefresh={true}
                                xscroll={true}
                                pageSize={10}
                                selected={(office) => selectedHandler(office)}
                                moreFilters={moreFilters()}
                                forceShowFilters={true}
                            />
                        </Panel.Body>
                    </Panel>
                </>
            }
        </>
    );
}

export default BranchOfficesTab;